import { type RefCallBack } from 'react-hook-form';

/**
 * Creates a ref callback for form fields that scrolls the element into view
 * when react-hook-form triggers focus on validation error (shouldFocusError).
 *
 * Needed because custom fields (DatePicker, react-select, TipTap) don't expose
 * a native focusable element — react-hook-form only calls .focus() on the ref,
 * so we provide an object whose focus() scrolls instead.
 */
export function scrollFocusRef(ref: RefCallBack) {
  return (el: HTMLElement | null) => {
    if (!el) {
      ref(null);
      return;
    }
    ref({
      focus: () => el.scrollIntoView({ behavior: 'smooth', block: 'center' }),
    });
  };
}
